import moment from "moment";
// Loads the Japanese month/weekday names. The locale is passed on every call
// below, so the output never depends on moment's global locale.
import "moment/locale/ja";
import { PAYLOAD_DATE_FORMAT, SUMMARY_DATE_FORMAT } from "./constants";

/**
 * The app sets moment's default timezone to UTC (utils/customMoment.js), but
 * the pickers hand back Dates at the guest's *local* midnight / time. Reading
 * those through moment would shift them (23:00 in Jakarta -> 16:00). So the
 * calendar fields are copied out with plain Date methods first.
 */
const toCalendarMoment = (date) => moment([date.getFullYear(), date.getMonth(), date.getDate()]);

const padTwoDigits = (number) => String(number).padStart(2, "0");

/** Date from the time picker -> "HH:mm" in the guest's own clock. */
export const formatPickedTime = (date) =>
  date ? `${padTwoDigits(date.getHours())}:${padTwoDigits(date.getMinutes())}` : "";

/** "HH:mm" -> a Date today at that local time, which the time picker expects. */
export const parsePickedTime = (timeText) => {
  if (!timeText) return null;
  const [hours, minutes] = timeText.split(":").map(Number);
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);
  return date;
};

/** "2026-10-20 (Tue)" for the request body, always in English. */
export const formatPayloadDate = (date) =>
  date ? toCalendarMoment(date).locale("en").format(PAYLOAD_DATE_FORMAT) : "";

/**
 * A picked date as the guest reads it:
 *   en -> "Aug. 11th, 2023 (FRI)"
 *   jp -> "2023年8月11日(金)"
 */
export const formatDisplayDate = (date, language) => {
  if (!date) return "";
  if (language === "en") {
    const formatted = toCalendarMoment(date).locale("en").format(SUMMARY_DATE_FORMAT.en);
    // The design shows the weekday in capitals: "(FRI)".
    return formatted.replace(/\(([a-z]+)\)$/i, (weekday) => weekday.toUpperCase());
  }
  return toCalendarMoment(date).locale("ja").format(SUMMARY_DATE_FORMAT.jp);
};
